import {
  NewsRoute,
  SolitaireHorizontalMoveRoute,
  SolitaireMovesCardsRoute,
  SolitaireTermsExplainedRoute,
  SolitaireUndoTrickRoute,
} from '../news'
import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | Game News & Updates',
  description:
    "Stay updated with the latest game news from Avia! Get updates on new features, seasonal events, and more. Don't miss out on exciting game announcements!",
  keywords: ['game news'],
  path: NewsRoute,
}

export const NewsMetaData = generateMetadata(MetaData)

export const SolitaireTermsExplainedMetaData = generateMetadata({
  title: 'Solitaire Clash Guide 101: Master Solitaire Card Game Terms',
  description:
    'New to Solitaire Clash? This guide breaks down essential solitaire card game terms so you can play with confidence and sharpen your strategy.',
  keywords: [],
  path: SolitaireTermsExplainedRoute,
})

export const SolitaireUndoTrickMetaData = generateMetadata({
  title: 'How to Use Undo Like a Pro in Solitaire Clash (Simple 4-Step Trick)',
  description:
    'Learn how to use the undo feature in Solitaire to reveal hidden cards, make better decisions, and boost your opportunities of winning.',
  keywords: [],
  path: SolitaireUndoTrickRoute,
})

export const SolitaireMovesCardsMetaData = generateMetadata({
  title: 'How to Win Solitaire Clash with One Simple Move',
  description:
    'Stuck in Solitaire Clash? Learn how moving cards down from the foundation can unlock winning moves. Master smart strategies to improve your solitaire gameplay.',
  keywords: [],
  path: SolitaireMovesCardsRoute,
})

export const SolitaireHorizontalMoveMetaData = generateMetadata({
  title: 'Solitaire Clash Strategy: Unlock Hidden Cards with the Horizontal Move',
  description:
    'Unlock hidden cards and boost your win rate with a smart solitaire strategy. Try this simple horizontal move in Solitaire Clash and play like a pro.',
  keywords: [],
  path: SolitaireHorizontalMoveRoute,
})
